export default {"src":"/_next/static/media/minus_bracket.1f62eaaa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};